import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import i18next from 'i18next'

export default function LangSync() {
  const location = useLocation()
  const navigate = useNavigate()
  const currentLang = i18next.language

  useEffect(() => {
    const params = new URLSearchParams(location.search)

    // if ?lang is missing OR different → update it
    if (params.get('lang') !== currentLang) {
      params.set('lang', currentLang)
      navigate(
        {
          pathname: location.pathname,
          search: params.toString(),
        },
        { replace: true }
      )
    }
  }, [location.pathname, currentLang])

  return null
}
